export default "/images/logo-1.png?2007573a019383a7527cdbaae9792d2b";